import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/credit-reports-b2c/{creditReportId}/set-report-price-and-title']['POST'];

type Input = ThisApi['params'] & ThisApi['body'];

const sendCreditReportPriceAndTitle = async ({
  creditReportId,
  price,
  priceTitle,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/credit-reports-b2c/${creditReportId}/set-report-price-and-title`, {
    price,
    priceTitle,
  });

  return response.data;
};

export default sendCreditReportPriceAndTitle;
